import React from 'react';
import './App.css';
import { LanguageProvider } from './context/LanguageContext';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Certifications from './components/Certifications';
import MaintenanceContracts from './components/MaintenanceContracts';
import Projects from './components/Projects';
import Reviews from './components/Reviews';
import About from './components/About';
import Sponsorship from './components/Sponsorship';
import QuoteForm from './components/QuoteForm';
import Contact from './components/Contact';
import Footer from './components/Footer';
import LiveChat from './components/LiveChat';

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <Header />
        <main>
          <Hero />
          <Services />
          <MaintenanceContracts />
          <Certifications />
          <Projects />
          <Reviews />
          <About />
          <Sponsorship />
          <QuoteForm />
          <Contact />
        </main>
        <Footer />
        <LiveChat />
        <Toaster position="top-right" />
      </div>
    </LanguageProvider>
  );
}

export default App;
